export class TaskClassification {
    public ItemId: number;
    public NotificationId: string;
}
